import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'

import cz from './locales/cz.json'
import hu from './locales/hu.json'
import sk from './locales/sk.json'

const locale = window.settings.version.toLowerCase() || 'cz'

const czSkPluralRule = (choice) => {
  if (choice === 1) {
    return 0 // singular
  }
  if (choice >= 2 && choice <= 4) {
    return 1 // plural for 2-4
  }
  return 2 // plural for 5+ or 0
}

export function setupI18n(options = { locale }) {
  const i18n = createI18n({
    ...options,
    legacy: false,
    pluralRules: {
      cz: czSkPluralRule,
      hu: czSkPluralRule,
      sk: czSkPluralRule
    },
    messages: {
      cz,
      hu,
      sk
    }
  })
  setI18nLanguage(i18n, options.locale)
  return i18n
}

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  document.querySelector('html').setAttribute('lang', locale)
}

export async function loadLocaleMessages(i18n, locale) {
  // load locale messages with dynamic import
  const messages = await import(`./locales/${locale}.json`)

  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default)

  return nextTick()
}
